export default {
    navigationBarTitleText: intl.get('mobileLandingPage.title.cloudService'),
    navigationBarBackgroundColor: "#DF773C",
};
